module.exports = __webpack_public_path__ + "static/ro-trainings-2-0b8a510e13bf9d4873477a7245c5fc02.jpg";